import React from 'react'
import Header from '../../components/Header'
import { Toast, Modal } from 'antd-mobile';
import './popularityList.less'
import { audioRank, addPraise, audioReport } from '../../api/sound'
import { getQueryString, getNickName, timeFormat, isWeChat } from '../../utils/utils'
import DocumentTitle from 'react-document-title'
import Cookies from 'js-cookie'
import { global } from '../../config/index'

export default class SoundPopularityList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      paused: true,
      currentAudio: {},
      feedbackModal: false,
      feedbackItem: {},
      sign: '',
      client: isWeChat(),
    }
  }

  componentWillMount = () => {
    let sign = getQueryString('sign') || Cookies.get('sign')
    if (!sign && this.state.client == 1) {
      let url = global.wxAuthorizeBaseUrl + '?op=wxWebAudioLogin&from_sso_id=' + getQueryString('from_sso_id') + '&invite_type='
        + getQueryString('invite_type') + '&picture_id=' + getQueryString('picture_id') + '&channel_id=' + getQueryString('channel_id')
        + '&reply_id=' + getQueryString('reply_id') + '&audio_id=' + getQueryString('audio_id') + '&base_url=' + global.href + 'lg/sound/index'
      window.location.href = url;
    } else {
      this.setState({
        sign: true
      })
    }
  }

  componentDidMount() {
    let sign = getQueryString('sign') || Cookies.get('sign')
    if (sign) {
      this.requestList()
      this.initPlay()
    }
  }

  requestList = () => {
    audioRank({ audio_id: getQueryString('audio_id') }).then((res) => {
      this.setState({
        data: res
      })
    })
  }

  initPlay = () => {
    let audio = this.refs.audio
    let _this = this

    //开始播放：
    audio.onplay = function () {
      _this.setState({
        paused: false
      })
    }

    //暂停播放：
    audio.onpause = function () {
      _this.setState({
        paused: true
      })
    }
  }

  onClose = key => () => {
    this.setState({
      [key]: false,
    });
  }

  prePlay = (item) => {
    let audio = this.refs.audio
    if (!this.state.currentAudio.id || this.state.currentAudio.id != item.id) {
      audio.src = item.mp3
      this.setState({
        currentAudio: item
      })
    }
    if (audio.paused) {
      audio.play();
    } else {
      audio.pause();
    }
  }

  //点赞
  handleAddPraise = (item) => {
    if (item.is_praise) {
      Toast.info('你已经点过赞了', 1.5)
      return;
    }
    addPraise({ reply_id: item.id, audio_id: item.audio_id }).then((res) => {
      Toast.info('点赞成功')
      this.requestList()
    })
  }

  //举报
  handleFeedback = (item) => {
    this.setState({
      feedbackModal: true,
      feedbackItem: item
    })
  }

  //举报接口
  handleAudioReport = () => {
    let item = this.state.feedbackItem
    let _this = this
    audioReport({ reply_id: item.id, audio_id: item.audio_id }).then((res) => {
      _this.setState({
        feedbackModal: false
      })
      Toast.info('举报成功')
    })
  }

  render() {
    let { paused, data, currentAudio, sign, client } = this.state
    return (
      <DocumentTitle title="人气榜单">
        {
          client != 1 || sign ?
            <article className="sound-popularity-list-wrap">
              <Header name="人气榜单" />
              {
                data && data.rank_list && data.rank_list.length > 0 ?
                  <div className="header-container">
                    <h3 className="title">本期点赞人气榜单</h3>
                    <p className="time">{timeFormat(data.date_time, 16, '.')}</p>
                  </div>
                  : ''
              }

              {/* 精彩回答 */}
              {
                data && data.rank_list && data.rank_list.length > 0 ?
                  <div className="answer-list">
                    {
                      data.rank_list.map((item, i) => (
                        <div className="item" key={i}>
                          <div className="medal">
                            {
                              i < 3 ? <div className="medal-img" style={{ backgroundImage: `url(${require('../../images/sound/medal/' + Number.parseInt(i + 1) + '.png')})` }} />
                                :
                                <div className="medal-img" style={{ backgroundImage: `url(${require('../../images/sound/medal/bg.png')})` }}>
                                  <span className="text">{Number.parseInt(i + 1)}</span>
                                </div>
                            }

                          </div>
                          <div className="avatar" onClick={() => { this.handleFeedback(item) }}>
                            <img src={item.icon} alt="" />
                          </div>
                          <div className="info">
                            <div className="row">
                              <span className="nickname">{getNickName(item.nickname)}</span>
                              <span className="time">{timeFormat(item.modify_date, 16, '.')}</span>
                            </div>
                            <div className="row">
                              <div className="voice" onClick={() => { this.prePlay(item) }}>
                                {item.second}s
                        <img className="voice_wifi"
                                  src={currentAudio.id == item.id && !paused ?
                                    require('../../images/sound/wifi_active.gif')
                                    : require('../../images/sound/wifi.png')} alt="" />
                              </div>
                              <div className="zan-btn" onClick={() => { this.handleAddPraise(item) }}>
                                <img src={require(`../../images/sound/${item.is_praise ? 'mini_flower_btn_active' : 'mini_flower_btn'}.png`)} alt="" />
                                <span className="zan-num">{item.praise_count}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    }
                  </div>
                  :
                  <div className="no-content">
                    暂时还没有小朋友回答，快去抢先回答吧～
            </div>
              }
              <div style={{ height: '2rem' }}></div>
              <audio ref="audio" src="" style={{ display: 'none' }}>
                Your browser does not support the audio element.
          </audio>

              <Modal
                visible={this.state.feedbackModal}
                className="sound-answer-list-modal"
                transparent
                maskClosable={true}
                onClose={this.onClose('feedbackModal')}
              >
                <div className="modal-container1">
                  <div className="content">
                    <div className="title">您是否要举报这条回答</div>
                    <div className="button">
                      <div className="left" onClick={this.onClose('feedbackModal')}>取消</div>
                      <div className="right" onClick={this.handleAudioReport}>确定</div>
                    </div>
                  </div>
                </div>
              </Modal>
            </article>
            : ''
        }
      </DocumentTitle>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/sound/popularityList.js